'use client'

import LoadingBar from 'react-top-loading-bar'
import { useState, useEffect } from 'react'
import { usePathname } from 'next/navigation'
import { colors } from '@/clients/styles/theme'

export default function RouteChangeProgress() {
  const [progress, setProgress] = useState(0)
  const pathname = usePathname()

  // サーバーサイドレンダリング時のデバッグログ
  if (typeof window === 'undefined') {
    console.log('Server-side rendering RouteChangeProgress - this should not happen');
  }


  useEffect(() => {
    // パスが変更されたときにプログレスバーを表示
    setProgress(40)
    
    // 少し遅延させてから完了状態にする
    const timer = setTimeout(() => {
      setProgress(100)
    }, 100)
    
    return () => clearTimeout(timer)
  }, [pathname])

  return (
    <LoadingBar
      color={colors.border.purple}
      progress={progress}
      waitingTime={400}
      onLoaderFinished={() => {
        setProgress(0)
      }}
    />
  )
}